package com.dwarshb.bms

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.automirrored.filled.ArrowForward
import androidx.compose.material.icons.filled.ContentCopy
import androidx.compose.material3.Button
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalClipboardManager
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun TicketConfirmationScreen(
    screenTitle: String = "My Ticket",
    trip: Trip,
    booking: Booking,
    onBack: () -> Unit
) {
    Scaffold { innerPadding ->
        Box(
            modifier = Modifier
                .padding(innerPadding)
                .fillMaxSize()
                .background(
                    brush = Brush.verticalGradient(
                        colors = ThemeColor.pinkGradientBackgorund
                    )
                )
        ) {
            Column {
                TopAppBar(
                    title = { Text(screenTitle, color = Color.White) },
                    navigationIcon = {
                        IconButton(onClick = onBack) {
                            Icon(
                                Icons.AutoMirrored.Filled.ArrowBack,
                                contentDescription = "Back",
                                tint = Color.White
                            )
                        }
                    },
                    colors = TopAppBarDefaults.topAppBarColors(containerColor = Color.Transparent)
                )
                Spacer(modifier = Modifier.height(32.dp))
                TicketCard(trip,booking)
            }
        }
    }
}

@Composable
fun TicketCard(trip: Trip, booking: Booking) {
    Column {
        Card(
            shape = RoundedCornerShape(24.dp),
            modifier = Modifier
                .padding(24.dp)
                .align(Alignment.CenterHorizontally),
            elevation = CardDefaults.cardElevation(8.dp)
        ) {
            Column(
                modifier = Modifier
                    .background(Color.White)
                    .verticalScroll(rememberScrollState())
                    .padding(24.dp)
            ) {
                Row(
                    Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    Column {
                        Text(
                            trip.departureLocation,
                            fontWeight = FontWeight.Bold,
                            fontSize = 24.sp
                        )
                        Text(trip.departureDate, fontSize = 12.sp)
                    }
                    Icon(Icons.AutoMirrored.Default.ArrowForward, contentDescription = null)
                    Column(horizontalAlignment = Alignment.End) {
                        Text(
                            trip.arrivalLocation,
                            fontWeight = FontWeight.Bold,
                            fontSize = 24.sp
                        )
                        Text(trip.arrivalDate, fontSize = 12.sp)
                    }
                }

                HorizontalDivider(modifier = Modifier.padding(vertical = 16.dp))

                repeat(booking.passengerDetails.size) {
                    Row(
                        Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.SpaceBetween
                    ) {
                        Column {
                            Text("Passenger", fontWeight = FontWeight.Bold)
                            Text(booking.passengerDetails[it])
                        }
                        Column(horizontalAlignment = Alignment.End) {
                            Text("Seat", fontWeight = FontWeight.Bold)
                            Text(booking.selectedSeats[it])
                        }
                    }
                }
                HorizontalDivider(modifier = Modifier.padding(vertical = 16.dp))
                Row(
                    Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    Column {
                        Text("Email Id", fontWeight = FontWeight.Bold)
                        Text(booking.email)
                    }
                    Column(horizontalAlignment = Alignment.End) {
                        Text("Phone", fontWeight = FontWeight.Bold)
                        Text(booking.phoneNumber)
                    }
                }
                Spacer(modifier = Modifier.height(12.dp))
                Row(
                    Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    Column {
                        Text("Date", fontWeight = FontWeight.Bold)
                        Text(trip.departureDate)
                    }
                    Column(horizontalAlignment = Alignment.End) {
                        Text("Time", fontWeight = FontWeight.Bold)
                        Text(trip.departureTime)
                    }
                }

                Spacer(modifier = Modifier.height(12.dp))

                Row(
                    Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    Column {
                        Text("Bus Category", fontWeight = FontWeight.Bold)
                        Text(trip.coachCategory)
                    }
                    Column(horizontalAlignment = Alignment.End) {
                        Text("Bus Type", fontWeight = FontWeight.Bold)
                        Text(trip.coachType)
                    }
                }
                Spacer(modifier = Modifier.height(24.dp))
                Row(
                    Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    Column {
                        Text("Cost Per Seat", fontWeight = FontWeight.Bold)
                        Text("$${trip.costPerSeat}")
                    }
                    Column(horizontalAlignment = Alignment.End) {
                        Text("Total Cost", fontWeight = FontWeight.Bold)
                        Text("$${booking.bookingCost}")
                    }
                }
                HorizontalDivider(
                    modifier = Modifier.padding(16.dp),
                    thickness = 0.5.dp, color = Color.Black
                )
                Text(
                    "Organizer Details",
                    modifier = Modifier.fillMaxWidth().padding(16.dp),
                    textAlign = TextAlign.Center,
                    fontWeight = FontWeight.Bold,
                    fontSize = 18.sp
                )
                Row(
                    Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    Column {
                        Text("Name", fontWeight = FontWeight.Bold)
                        Text(trip.organizer.name)
                    }
                    Column(horizontalAlignment = Alignment.End) {
                        Text("Contact", fontWeight = FontWeight.Bold)
                        Text(trip.organizer.phoneNumber)
                    }
                }
                Text(
                    "To cancel the reservation, you can contact organizer",
                    modifier = Modifier.fillMaxWidth().padding(8.dp),
                    textAlign = TextAlign.Center
                )
                Spacer(modifier = Modifier.height(24.dp))
                Row(
                    Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    Column {
                        Text("Code", fontWeight = FontWeight.Bold)
                        Text(trip.id)
                    }

                    val copyManager = LocalClipboardManager.current
                    Column(horizontalAlignment = Alignment.End) {
                        IconButton(onClick = {
                            copyManager.setText(AnnotatedString(trip.id))
//                                    copyToClipboard(trip.id)
                        }) {
                            Icon(Icons.Default.ContentCopy, "")
                        }
                    }
                }
            }
        }
    }
}